import React from 'react';

interface ChartSkeletonProps {
  title?: string;
  height?: number;
}

const ChartSkeleton: React.FC<ChartSkeletonProps> = ({ title, height = 400 }) => {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-sm p-6 border border-gray-100 dark:border-gray-700 relative overflow-hidden">
      {title && (
        <div className="h-7 bg-gray-200 dark:bg-gray-700 rounded w-48 mb-6 shimmer"></div>
      )}
      <div className={`bg-gray-100 dark:bg-gray-700 rounded-lg shimmer`} style={{ height: `${height}px` }}></div>
      
      <style>{`
        @keyframes shimmer {
          0% {
            background-position: -1000px 0;
          }
          100% {
            background-position: 1000px 0;
          }
        }
        
        .shimmer {
          background: linear-gradient(
            90deg,
            #f0f0f0 0%,
            #e0e0e0 20%,
            #f0f0f0 40%,
            #f0f0f0 100%
          );
          background-size: 1000px 100%;
          animation: shimmer 2s infinite linear;
        }
        
        .dark .shimmer {
          background: linear-gradient(
            90deg,
            #374151 0%,
            #4b5563 20%,
            #374151 40%,
            #374151 100%
          );
          background-size: 1000px 100%;
          animation: shimmer 2s infinite linear;
        }
      `}</style>
    </div>
  );
};

export default ChartSkeleton;

